import { useState, useEffect, useContext } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { CgFileDocument } from "react-icons/cg";
import { FiAlertCircle, FiCheck, FiX } from "react-icons/fi";
import AddBackground from "../../components/AddBackground";
import DocEdit from "../../components/DocEdit";
import { Container, Content, ContentMessage } from "./styles";
import api from "../../services/api";
import QuestionContext from "../../contexts/QuestionContext";
import { ProcessPropInfoTypes } from "./types";

function ProcessPropInfo() {
	const {
		tags,
		documents,
		necessaryDocuments,
		setNecessaryDocuments,
		process,
		reloadProcess,
	} = useContext(QuestionContext);
	const [show, setShow] = useState("hidden");
	const [message, setMessage] = useState<string | null>(null);
	const [docs, setDocs] = useState<ProcessPropInfoTypes[]>([]);
	const [selectedDocument, setSelectedDocument] = useState<any>();
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		(async () => {
			try {
				const formatedDocs = documents?.map((doc: any) => ({
					id: doc.id,
					name: doc.name,
					location: doc.location,
					documentTag: doc.documentTag?.name,
				}));

				setDocs(formatedDocs);
				setLoading(false);
			} catch (error) {
				return error;
			}
		})();
	}, [documents]);

	const sendTagChange = async (newDocumentTagId: number) => {
		try {
			await api.post("/data/documents/tag", {
				documentId: selectedDocument.id,
				documentTagId: newDocumentTagId,
			});

			reloadProcess();
		} catch (error) {
			return error;
		}
	};

	const handleSelectDocument = (doc: any) => {
		setSelectedDocument(doc);
		setShow("show");
	};

	const handleRemoveDocument = (id: number) => {
		setNecessaryDocuments((state: any) =>
			state.filter((document: any) => document !== id),
		);
	};

	const Document = ({
		doc,
		handleSelectDocument,
	}: {
		doc: ProcessPropInfoTypes;
		handleSelectDocument: (tag: any) => void;
		key: number;
	}) => {
		return (
			<div
				className='doc-wrapper'
				onClick={() => handleSelectDocument(doc)}>
				<div className='title-wrapper'>
					<p
						className='doc-title'
						title={doc?.documentTag || "Documento sem tag"}>
						{doc?.documentTag || "Documento sem tag"}
					</p>
				</div>
				<div className='icons-wrapper'>
					<div className='icon'>
						<CgFileDocument className='svg' />
					</div>

					<div className='icon'>
						<FiAlertCircle className='svg' />
					</div>
				</div>
			</div>
		);
	};

	const NecessaryDocument = ({ tag }: any) => {
		const teste = documents.map((doc: any) => doc.documentTagId);
		const exists = teste.includes(tag);
		const document = tags.filter((doc: any) => doc.id === tag)[0];

		return (
			<div
				className='doc-wrapper'
				style={exists ? { color: "green" } : { color: "red" }}>
				<div className='title-wrapper'>
					<p
						className='doc-title'
						style={exists ? { color: "green" } : { color: "red" }}
						title={document?.name || "Documento sem tag"}>
						{document?.name || "Documento sem tag"}
					</p>
				</div>
				<div className='icons-wrapper'>
					<div className='icon'>
						<CgFileDocument className='svg' />
					</div>

					<div className='icon'>
						{exists ? (
							<FiCheck className='svg' />
						) : (
							<FiX
								className='svg'
								onClick={() =>
									handleRemoveDocument(document.id)
								}
								title='Clique para remover esse documento!'
							/>
						)}
					</div>
				</div>
			</div>
		);
	};

	return (
		<Container>
			{loading ? (
				"Carregando..."
			) : (
				<Content>
					<div>
						{process?.proponent_name
							? (() => {
									const slicedName =
										process?.proponent_name.split(" ");

									const firstName =
										slicedName !== undefined
											? slicedName[0].toLowerCase()
											: null;

									const lastName = slicedName !== undefined;

									return (
										<div
											className='process-details'
											key={process.id}>
											<div className='process-prop-name'>
												<p id='prop-name'>
													{process ? firstName : null}{" "}
													<br />
													{process
														? lastName
														: null}{" "}
													<br />
												</p>
												<p className='prop-cpf'>
													{process !== undefined
														? process.cpf
														: null}
												</p>
											</div>
											<hr id='doc-line' />

											<div className='docs-container'>
												{docs?.map(
													(
														doc: any,
														index: number,
													) => {
														return (
															<Document
																key={index}
																doc={doc}
																handleSelectDocument={
																	handleSelectDocument
																}
															/>
														);
													},
												)}
											</div>

											{necessaryDocuments ? (
												<>
													<hr id='doc-line' />
													<p className='prop-info'>
														Documentos Necessários
													</p>

													<div className='docs-container'>
														{necessaryDocuments.map(
															(tag: number) => {
																return (
																	<NecessaryDocument
																		tag={
																			tag
																		}
																	/>
																);
															},
														)}
													</div>
												</>
											) : (
												<></>
											)}

											<div
												className='missing-docs'
												id='missing'>
												<p>Faltando documentos</p>
											</div>
										</div>
									);
							  })()
							: ""}
					</div>
				</Content>
			)}

			{show === "show" && selectedDocument ? (
				<AddBackground className='show'>
					<OutsideClickHandler
						onOutsideClick={() => setShow("hidden")}>
						<DocEdit
							sendTagChange={sendTagChange}
							show={setShow}
							doc={selectedDocument}
						/>
					</OutsideClickHandler>
				</AddBackground>
			) : (
				""
			)}

			{message ? (
				<AddBackground className='show'>
					<OutsideClickHandler
						onOutsideClick={() => setMessage(null)}>
						<ContentMessage>{message}</ContentMessage>
					</OutsideClickHandler>
				</AddBackground>
			) : (
				""
			)}
		</Container>
	);
}

export default ProcessPropInfo;
